window.o_global = window.o_global || {};
window.o_global.rwdTools = window.o_global.rwdTools || {};
window.o_global.device = window.o_global.device || {};
window.o_global.device.screen = window.o_global.device.screen || {};

/**
 * RWD-Tools for dealing with responsive issues
 */ window.o_global.rwdTools = (function () {
  /**
   * Public method to set the devSpecs-Cookie with the Device-Dimensions.
   *
   * @see: https://github.com/otto-ec/shozu_vcl/blob/main/templates/varnish/features/breakpoint.vcl.j2
   */
  function setDevSpecsCookie() {
    let bp = "";

    if (
      window.o_global.device &&
      window.o_global.device.breakpoint &&
      typeof window.o_global.device.breakpoint.getCurrentBreakpoint ===
        "function"
    ) {
      bp = `bp=${window.o_global.device.breakpoint.getCurrentBreakpoint()}`;
    }

    const cookieValue = `w=${document.documentElement.clientWidth}&h=${document.documentElement.clientHeight}&${bp}`;
    const expireDate = new Date();

    expireDate.setTime(expireDate.getTime() + 10 * 365 * 24 * 60 * 60 * 1000);
    document.cookie = `devSpecs=${cookieValue};path=/;domain=.otto.de;expires=${expireDate.toGMTString()}`;
  }

  /**
   * Register a listener for breakpoint change.
   */
  function handleBreakpointChange() {
    try {
      window.o_global.device.breakpoint.registerChangeListener(function () {
        setDevSpecsCookie();
      });
    } catch (e) {}
  }

  setDevSpecsCookie();
  handleBreakpointChange();

  return {
    setDevSpecsCookie,
    handleBreakpointChange,
  };
})();
